<template>
  <div id="app" class="glad-app">
    <router-view />
    <ErrorModal />
  </div>
</template>

<script>
import ErrorModal from '@/components/base/ErrorModal';
export default {
  name: 'App',
  components: {
    ErrorModal
  }
};
</script>

<style lang="scss">
.glad-app {
  min-width: 1280px;
}
</style>
